module.exports = __webpack_public_path__ + "img/benefits-students-1.2d4e39f6.svg";